module.exports = __webpack_public_path__ + "media/images/writer/community/sp-headline-about-community@3x-e59baf8ade41788d7a227207d67e0cf7.png";